module.exports = __webpack_public_path__ + "img/vertical_7_4_8004.dafd1cb7.png";